<script lang="ts">
  import { onMount } from "svelte";

  import { fade } from "svelte/transition";
  import BackEnd from "../../lib/BackEnd";
  import type { IS3Object, IUser } from "../../types";
  import UserFileList from "./UserFileList.svelte";
  import UserForm from "./UserForm.svelte";

  import UserList from "./UserList.svelte";

  let selectedUser: IUser;
  let fileList: IS3Object[] = [];

  const loadCases = () => {
    BackEnd.getAdminCaseList().then((ok) => {
      fileList = ok
        .map((i: IS3Object) => {
          let path = i.Key.split("/");
          i._filename = path[path.length - 1];
          i._cat = new Date(i.LastModified);
          return i;
        })
        .sort((a, b) => b._cat - a._cat);
    });
  };
  onMount(loadCases);
</script>

<section in:fade>
  <nav>
    <UserList
      on:select={(u) => {
        selectedUser = u.detail;
      }}
    />
  </nav>
  <main>
    {#if selectedUser != undefined}
      <UserForm user={selectedUser} />
      <hr />
      <UserFileList
        fileList={fileList.filter((f) => f.Key.match("^" + selectedUser.key))}
      />
    {/if}
  </main>
</section>

<style>
  section {
    display: grid;
    width: 100%;
    height: 100%;
    grid-template:
      [main-left] "nav  main" 1fr [main-right]
      [footer-left] "nav  foot" 30px [footer-right]/ 350px 1fr;
  }

  nav {
    grid-area: nav;
    font-size: 0.8rem;
    padding: 0.5rem;
    overflow-y: auto;
  }

  main {
    height: 90%;
    grid-area: main;
    font-size: 0.8rem;
    padding: 0.5rem;
    overflow-y: auto;
  }

  footer {
    border-top: solid 1px lightgray;
    grid-area: foot;
    text-align: center;
    font-size: 0.8rem;
    padding: 0.5rem;
  }
</style>
